import styled from 'styled-components';

const Chat = styled.button`
  border: none;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #215988;
  border-radius: 99px;
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

export { Chat };
